export { default as userReducer } from './userReducer.mjs';
import contactReducer from './contactReducer.mjs';
export { default as contactReducer } from './contactReducer.mjs';
export { default as loginReducer } from './loginReducer.mjs';
export { checkIsLoggedIn, login, logout, setIsLoading } from './loginActions.mjs';
export { createUser, deleteUser, getUserById, getUsers, setCurrentUser, updateUser } from './userActions.mjs';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { C as CONTACT_SUBMIT, D as DELETE_CONTACT, G as GET_CONTACTS, a as GET_CONTACT } from './types-0b7e03a3.js';
export { default as LoginPage } from './LoginPage.mjs';
export { default as PasswordResetPage } from './PasswordResetPage.mjs';
export { default as Sidebar } from './Sidebar.mjs';
import { L as ListOptions } from './userList.component-1f92430e.js';
export { L as ListOptions, u as UserList } from './userList.component-1f92430e.js';
export { default as CreateUserPage } from './CreateUserPage.mjs';
export { default as EditUserPage } from './EditUserPage.mjs';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Swal$1 from 'sweetalert2';
import { Pagination } from 'dg-pagination';
import { dgWithReducer, DgAccordianItem } from 'dg-utils';
export { default as ProtectedRoute } from './ProtectedRoute.mjs';
import '@babel/runtime/helpers/defineProperty';
import 'qs';
import '@babel/runtime/helpers/slicedToArray';
import 'react-router-dom';
import 'redux-form';
import 'dg-forms';
import './user.form-377bc838.js';
import 'qrcode';
import './spinner-bf1b67d8.js';
import 'prop-types';
import 'query-string';
import '@babel/runtime/helpers/objectWithoutProperties';

var createContact = function createContact(data) {
  return function (dispatch) {
    return new Promise( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fetch("".concat(process.env.REACT_APP_API_URL.includes('localhost') ? '' : process.env.REACT_APP_API_URL, "/api/v1/contacts/create"), {
                  method: "POST",
                  headers: {
                    "content-type": "application/json"
                  },
                  credentials: 'include',
                  body: JSON.stringify(data)
                }).then(function (res) {
                  return res.json();
                }).then(function (post) {
                  dispatch({
                    type: CONTACT_SUBMIT,
                    payload: post
                  });

                  if (!post.ok) {
                    reject(post);
                  } else {
                    resolve(post);
                  }
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
  };
};
var deleteContact = function deleteContact(contactId) {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      fetch("".concat(process.env.REACT_APP_API_URL.includes('localhost') ? '' : process.env.REACT_APP_API_URL, "/api/v1/contacts/delete/").concat(contactId), {
        method: "DELETE",
        headers: {
          "content-type": "application/json"
        },
        credentials: 'include'
      }).then(function (res) {
        return res.json();
      }).then(function (post) {
        dispatch({
          type: DELETE_CONTACT,
          payload: post
        });

        if (!post.ok) {
          reject(post);
        } else {
          resolve(post);
        }
      });
    });
  };
};
var getContacts = function getContacts(page, page_size) {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      fetch("".concat(process.env.REACT_APP_API_URL.includes('localhost') ? '' : process.env.REACT_APP_API_URL, "/api/v1/contacts/?page=").concat(page, "&page_size=").concat(page_size), {
        method: "GET",
        headers: {
          "content-type": "application/json"
        },
        credentials: 'include'
      }).then(function (res) {
        return res.json();
      }).then(function (post) {
        dispatch({
          type: GET_CONTACTS,
          payload: post
        });

        if (!post.ok) {
          reject(post);
        } else {
          resolve(post);
        }
      });
    });
  };
};
var getContactById = function getContactById(contactId) {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      fetch("".concat(process.env.REACT_APP_API_URL.includes('localhost') ? '' : process.env.REACT_APP_API_URL, "/api/v1/contacts/get/").concat(contactId), {
        method: "GET",
        headers: {
          "content-type": "application/json"
        },
        credentials: 'include'
      }).then(function (res) {
        return res.json();
      }).then(function (post) {
        dispatch({
          type: GET_CONTACT,
          payload: post
        });

        if (!post.ok) {
          reject(post);
        } else {
          resolve(post);
        }
      });
    });
  };
};

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ContactList = /*#__PURE__*/function (_Component) {
  _inherits(ContactList, _Component);

  var _super = _createSuper$1(ContactList);

  function ContactList(props) {
    var _this;

    _classCallCheck(this, ContactList);

    _this = _super.call(this, props);
    _this.state = {
      page: 0,
      page_size: 10,
      total_pages: 0,
      total_items: 0
    };
    _this.paginate = _this.paginate.bind(_assertThisInitialized(_this));
    _this["delete"] = _this["delete"].bind(_assertThisInitialized(_this));
    _this.onEdit = _this.onEdit.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ContactList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.paginate(this.state.page, this.state.page_size);
    }
  }, {
    key: "paginate",
    value: function paginate(page, page_size) {
      var _this2 = this;

      this.props.getContacts(page, page_size).then(function (res) {
        _this2.setState({
          page: res.page,
          page_size: res.page_size,
          total_pages: res.total_pages,
          total_items: res.total_items
        });
      })["catch"](function (res) {
        Swal$1.fire("Error", res.message, "error");
      });
    }
  }, {
    key: "delete",
    value: function _delete(event, value) {
      var _this3 = this;

      event.preventDefault();
      Swal$1.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(function (result) {
        if (result.isConfirmed) {
          _this3.props.deleteContact(value._id);

          Swal$1.fire("Deleted!", "contact has been deleted.", "success");

          _this3.componentDidMount();
        }
      });
    }
  }, {
    key: "onEdit",
    value: function onEdit(event, value) {
      event.preventDefault();
      this.props.navigate("/admin/contacts/edit/".concat(value._id));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var rows = [];

      if (this.props.contacts && this.props.contacts.contacts && this.props.contacts.contacts.length > 0) {
        rows = this.props.contacts.contacts.map(function (value, index) {
          return /*#__PURE__*/React.createElement("tr", {
            key: "contact_".concat(index)
          }, _this4.props.tableData ? _this4.props.tableData.filter(function (tdata) {
            return tdata.selector;
          }).map(function (tdata) {
            return /*#__PURE__*/React.createElement("td", null, value[tdata.selector]);
          }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", null, value.name ? value.name : ""), /*#__PURE__*/React.createElement("td", null, value.email ? value.email : ""), /*#__PURE__*/React.createElement("td", null, value.phone ? value.phone : ""), /*#__PURE__*/React.createElement("td", null, value.message ? value.message : "")), /*#__PURE__*/React.createElement("td", null, " ", value.createdAt ? "".concat(new Date(value.createdAt).toLocaleDateString(), " ").concat(new Date(value.createdAt).toLocaleTimeString()) : ""), /*#__PURE__*/React.createElement("td", null, " ", /*#__PURE__*/React.createElement(ListOptions, {
            onDelete: function onDelete(e) {
              return _this4["delete"](e, value);
            },
            onEdit: function onEdit(e) {
              return _this4.onEdit(e, value);
            }
          })));
        });
      } else {
        rows = [/*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
          colSpan: this.props.tableData ? this.props.tableData.length + 1 : "6"
        }, "No Contacts Available ..."))];
      }

      return /*#__PURE__*/React.createElement("main", {
        className: "dg-admin-main"
      }, /*#__PURE__*/React.createElement("div", {
        className: "dg-admin-List-Container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "dg-admin-header-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "header-text"
      }, /*#__PURE__*/React.createElement("h1", null, "All Contacts")), /*#__PURE__*/React.createElement("div", {
        className: "header-button"
      })), /*#__PURE__*/React.createElement("div", {
        className: "dg-admin-list"
      }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, this.props.tableData ? this.props.tableData.map(function (data) {
        return /*#__PURE__*/React.createElement("th", null, data.heading);
      }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("th", null, "Name"), /*#__PURE__*/React.createElement("th", null, "Email"), /*#__PURE__*/React.createElement("th", null, "Phone"), /*#__PURE__*/React.createElement("th", null, "Message"), /*#__PURE__*/React.createElement("th", null, "Created On"), /*#__PURE__*/React.createElement("th", null, "Actions")))), /*#__PURE__*/React.createElement("tbody", null, rows)), /*#__PURE__*/React.createElement(Pagination, {
        type: "Standard",
        paginate: this.paginate,
        page_size: this.state.page_size,
        page: this.state.page,
        total_pages: this.state.total_pages,
        total_items: this.state.total_items
      }))));
    }
  }]);

  return ContactList;
}(Component);

var mapStateToProps$1 = function mapStateToProps(state) {
  return {};
};

var mapDispatchToProps$1 = function mapDispatchToProps(dispatch) {
  return {};
};

var contactList_component = connect(mapStateToProps$1, mapDispatchToProps$1)(dgWithReducer(ContactList, "contacts", contactReducer));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ViewContact = /*#__PURE__*/function (_Component) {
  _inherits(ViewContact, _Component);

  var _super = _createSuper(ViewContact);

  function ViewContact() {
    _classCallCheck(this, ViewContact);

    return _super.apply(this, arguments);
  }

  _createClass(ViewContact, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var urlParams = window.location.pathname;
      var params = urlParams.split("/");
      console.log(params);

      if (params.length >= 4) {
        this.props.getContactById(params[4])["catch"](function (res) {
          Swal.fire("Error", res.message, "error");
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("main", {
        className: "dg-admin-main"
      }, /*#__PURE__*/React.createElement("div", {
        className: "dg-admin-List-Container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "dg-admin-header-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "header-text"
      }, /*#__PURE__*/React.createElement("h1", null, "View Contact")), /*#__PURE__*/React.createElement("div", {
        className: "header-button"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "accordian-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "accordian-wrapper"
      }, /*#__PURE__*/React.createElement(DgAccordianItem, {
        isExpanded: false,
        title: /*#__PURE__*/React.createElement("h2", null, "Contact Details"),
        component: /*#__PURE__*/React.createElement("div", {
          style: {
            flex: "1 1 100%"
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "col"
        }, /*#__PURE__*/React.createElement("div", {
          className: "contact-item"
        }, /*#__PURE__*/React.createElement("h3", null, "Name:"), " ", /*#__PURE__*/React.createElement("p", null, this.props.contacts.currentContact && this.props.contacts.currentContact.name && this.props.contacts.currentContact.name !== "" ? this.props.contacts.currentContact.name : "")), /*#__PURE__*/React.createElement("div", {
          className: "contact-item"
        }, /*#__PURE__*/React.createElement("h3", null, "Email:"), " ", /*#__PURE__*/React.createElement("p", null, this.props.contacts.currentContact && this.props.contacts.currentContact.email && this.props.contacts.currentContact.email !== "" ? this.props.contacts.currentContact.email : ""))), /*#__PURE__*/React.createElement("div", {
          className: "col"
        }, /*#__PURE__*/React.createElement("div", {
          className: "contact-item"
        }, /*#__PURE__*/React.createElement("h3", null, "Phone:"), " ", /*#__PURE__*/React.createElement("p", null, this.props.contacts.currentContact && this.props.contacts.currentContact.phone && this.props.contacts.currentContact.phone !== "" ? this.props.contacts.currentContact.phone : ""))))
      })), /*#__PURE__*/React.createElement("div", {
        className: "accordian-wrapper"
      }, /*#__PURE__*/React.createElement(DgAccordianItem, {
        isExpanded: true,
        title: /*#__PURE__*/React.createElement("h2", null, "Message"),
        component: /*#__PURE__*/React.createElement("div", {
          style: {
            flex: "1 1 100%"
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "col"
        }, /*#__PURE__*/React.createElement("div", {
          className: "contact-item"
        }, /*#__PURE__*/React.createElement("p", null, this.props.contacts.currentContact && this.props.contacts.currentContact.message && this.props.contacts.currentContact.message !== "" ? this.props.contacts.currentContact.message : ""))), /*#__PURE__*/React.createElement("div", {
          className: "col"
        }))
      }))));
    }
  }]);

  return ViewContact;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {};
};

var viewContact_component = connect(mapStateToProps, mapDispatchToProps)(dgWithReducer(ViewContact, "contacts", contactReducer));

export { contactList_component as ContactList, viewContact_component as ViewContactPage, createContact, deleteContact, getContactById, getContacts };
